import { createFeatureSelector, createSelector } from "@ngrx/store";
import { PracticeApplicationFeatures } from "../state/practice-application-feature.state";

export const selectPracticeApplicationFeature = createFeatureSelector<PracticeApplicationFeatures>('practiceApplicationFeatureStore');

export const selectPracticeFeaturesInfo = createSelector(
    selectPracticeApplicationFeature,
    (state: PracticeApplicationFeatures) => state.practiceApplicationFeaturesInformation
);